import React, { useEffect, useState } from "react";

const ScrollTop = () => {
    const [visible, setVisible] = useState(false);

    // Scroll event → show / hide button
    useEffect(() => {
        const toggleVisibility = () => {
            if (window.scrollY > 200) {
                setVisible(true);
            } else {
                setVisible(false);
            }
        };
        window.addEventListener("scroll", toggleVisibility);
        return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    // Scroll to top function
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    return (
        visible && (
            <div className="go_back" onClick={scrollToTop}>
                <i className="bi bi-chevron-double-up" />
            </div>
        )
    );
};

export default ScrollTop;
